var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icp"},[_c('img',{attrs:{"src":_vm.ICPImage,"alt":"ICP"}}),_vm._v(" "+_vm._s(_vm.icp)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }